// 講座タイプ
export const PLAN_TYPE_INVESTMENT = "INVESTMENT"; // 投資
export const PLAN_TYPE_INVESTMENT_LABEL = "投資";
export const PLAN_TYPE_BUSINESS = "BUSINESS"; // ビジネス
export const PLAN_TYPE_BUSINESS_LABEL = "ビジネス";
export const PLAN_TYPE_EDUCATION = "EDUCATION"; // 教育
export const PLAN_TYPE_EDUCATION_LABEL = "教育";
export type PLAN_TYPE = typeof PLAN_TYPE_INVESTMENT | typeof PLAN_TYPE_BUSINESS | typeof PLAN_TYPE_EDUCATION;

// フィーチャートグルに基づいて動的にPLAN_TYPE_LISTとPLAN_TYPE_LABEL_LISTを生成
export const getPlanTypeList = (): string[] => {
  const list = [PLAN_TYPE_INVESTMENT, PLAN_TYPE_BUSINESS];
  if (featureEducationPlanType()) {
    list.push(PLAN_TYPE_EDUCATION);
  }
  return list;
};

export const getPlanTypeLabelList = (): string[] => {
  const list = [PLAN_TYPE_INVESTMENT_LABEL, PLAN_TYPE_BUSINESS_LABEL];
  if (featureEducationPlanType()) {
    list.push(PLAN_TYPE_EDUCATION_LABEL);
  }
  return list;
};

// 後方互換性のため、デフォルトのリストも提供
export const PLAN_TYPE_LIST = [PLAN_TYPE_INVESTMENT, PLAN_TYPE_BUSINESS, PLAN_TYPE_EDUCATION];
export const PLAN_TYPE_LABEL_LIST = [PLAN_TYPE_INVESTMENT_LABEL, PLAN_TYPE_BUSINESS_LABEL, PLAN_TYPE_EDUCATION_LABEL];

export const getPlanTypeLabel = (type: PLAN_TYPE) => {
  const labelList = getPlanTypeLabelList();
  const typeList = getPlanTypeList();
  const index = typeList.indexOf(type);
  if (index === -1) {
    return "";
  }
  return labelList[index];
};
export const PLAN_TYPE_DEFAULT = PLAN_TYPE_INVESTMENT; // デフォルトの講座タイプ

// 配信ステータス。 unpublished:下書き, scheduled:配信前, live:配信中, live_stopped:配信停止, archived:アーカイブ済み, deleted:消失, ※配信前は、生配信スケジュールのレスポンス用のステータスになります
export type LIVE_STATUS = "unpublished" | "scheduled" | "live" | "live_stopped" | "archived" | "deleted";

// 配信系のコンテンツタイプ
export const enum STREAMING_CONTENT_TYPE {
  LIVE = "live_movie",
  SCHEDULE = "schedule",
  ARCHIVE = "archive_movie",
}

// コンテンツタイプ
export const enum CONTENT_TYPE {
  MOVIE = "movie",
  DOCUMENT = "document",
  ARTICLE = "article",
  LIVE_MOVIE = "live_movie",
  LIVE_SCHEDULE = "schedule",
  LIVE_ARCHIVE = "archive_movie",
}

export const CONTENT_TYPE_LIST = [
  CONTENT_TYPE.MOVIE,
  CONTENT_TYPE.DOCUMENT,
  CONTENT_TYPE.ARTICLE,
  CONTENT_TYPE.LIVE_MOVIE,
  CONTENT_TYPE.LIVE_SCHEDULE,
  CONTENT_TYPE.LIVE_ARCHIVE,
];

// 標準のページ内の表示件数
export const DEFAULT_PAGE_SIZE = 10;

// 講座、オーナーページ内の表示件数
export const PLAN_OWNER_PAGE_SIZE = 10;

// コンテンツページ内の表示件数
export const CONTENT_PAGE_SIZE = 20;

// 講座概要体験談数
export const PLAN_SUMMARY_REVIEW_SIZE = 3;

// コンテンツのソート
// random指定時の別ページ遷移時にはresponseのsortの文字列を入れる（nullの場合desc)
export type CONTENT_SORT_TYPE = "desc" | "asc" | "random" | string | undefined;

// コンテンツの公開ステータス。PUBLISH:公開, LIMITED:限定公開, PRIVATE:非公開
export const CONTENT_PUBLISH_STATUS = ["PUBLISH", "LIMITED", "PRIVATE"];
export const CONTENT_PUBLISH_STATUS_LABELS = ["公開", "限定公開", "非公開"];

export const getPublishStatusLabel = (status: string) => {
  const index = CONTENT_PUBLISH_STATUS.indexOf(status);
  if (index === -1) {
    return "";
  }
  return CONTENT_PUBLISH_STATUS_LABELS[index];
};

// チャプタータイトルの最大文字数
export const CHAPTER_TITLE_MAX_LENGTH = 100;

// コンテンツメニューのID
export const enum CONTENT_MENU_ID {
  LIVE = "live",
  MOVIE = "movie",
  DOCUMENT = "document",
  ARTICLE = "article",
}
